
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ProductInfoGalleryViewInRoom',
  mixins: [respUtility],
  props: {
    setQrCode: {
      type: Function,
      default: null,
    },
    urlMobileBtn: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showPopup: false,
    };
  },
  methods: {
    viewInRoomHandle() {
      this.openPopup();
      this.addARViewEvent();
    },
    addARViewEvent() {
      if (window.gtag) {
        window.gtag('event', 'ar_view_click', {
          event_category: 'AR Interaction',
          event_label: 'AR View Button Click',
        });
      }
    },
    openPopup() {
      this.showPopup = true;
      this.$nextTick(() => {
        this.setQrCode(this.$refs.arViewQrCode);
      });
    },
    closePopup() {
      this.showPopup = false;
    },
  },
};
